<template>
    <d-container fluid class="work-report-view main-content-container px-4">
      <!-- Page Header -->
      <d-row no-gutters class="page-header py-4">
        <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">Raport</span>
          <h3 class="page-title">Eksport uczniów</h3>
        </d-col>
      </d-row>

      <validation-observer
        ref="students-export-form"
        tag="form"
        style="width: 100%;"
        class="page-filters position-relative">

        <div
          v-if="!allFiltersDataLoaded"
          class="pb-3 pt-3 text-center overlay-loading"
          style="z-index: 100;">
          Trwa ładowanie danych&hellip;
        </div>

        <d-row class="ml-0 mb-3 w-100">
            <d-col md="4">
              <validation-observer
                      ref="download-form"
                      tag="form">
                <div class="form-group">
                  <label>
                    Wybierz rok
                  </label>
                  <validation-provider
                          rules="required"
                          name="duration"
                          v-slot="{ errors }">
                    <v-select
                            :options="dates"
                            style="width: 100%;"
                            class="form-control"
                            label="value"
                            v-model="date">
                    </v-select>
                  </validation-provider>
                </div>
              </validation-observer>
            </d-col>

          <d-col
            sm="4"
            class="d-flex justify-content-start align-items-center">
            <d-button
              theme="primary"
              class="mt-2"
              :disabled="actionInProgress"
              @click.prevent="downloadFile">
              Eksportuj uczniów
            </d-button>
          </d-col>
        </d-row>
      </validation-observer>

      <d-card style="width: 100%;">
        <d-alert
          show
          theme="info"
          class="mt-3">
          Aby eksportować uczniów należy wybrać rok szkolny i kliknąć przycisk "Eksportuj uczniów".
        </d-alert>
      </d-card>
    </d-container>
  </template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: 'students-export',
  components: { DatePicker },
  computed: {},
  data() {
    return {
      downloading: false,
      actionInProgress: false,
      allFiltersDataLoaded: false,
      date: {
        id: 0,
        value: 'Wybierz rok'
      },
      dates: [],
    }
  },
  mounted () {
    this.getDates();
  },
  methods: {
    getDates () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/reports/sio-years',
        outputKey: 'dates',
        loadedKey: 'loaded',
        noPagination: true,
        method: 'GET',
        successAction: () => {
          this.date = this.dates[this.dates.length - 1];
          this.dates.push({
            id: 0,
            value: 'Wybierz rok'
          });
          this.allFiltersDataLoaded = true;
        }
      });
    },
    downloadFile () {
      if (!this.date || this.date.id === 0) {
        Vue.swal({
          title: 'Nie wybrano roku',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        return;
      }
      Vue.set(this, 'downloading', true);
      this.$http.post('/patients/export', { year: this.date.value }, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'students_export.zip');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        Vue.set(this, 'downloading', false);
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        Vue.set(this, 'downloading', false);
      });
    }
  }
};
</script>

  <style lang="scss">
  .work-report-view .page-filters {
    .form-control {
      padding-bottom: 0;
      padding-left: 0;
      padding-top: 0;

      &.is-disabled {
        background-color: #f8f8f8;

        .v-select .vs__dropdown-toggle {
          background-color: #f8f8f8;
        }
      }

      .v-select .vs__dropdown-toggle {
        border: none!important;
      }
    }

    .mx-input {
      border: 1px solid #e1e5eb;
      box-shadow: none;
      padding-left: 8px;
    }
  }
  </style>
